<template>
  <div class="moduleStyle minHeight">
    <div class="tabs">
      <ul>
        <li
          :class="activeId == item.val ? 'tabs_active' : ''"
          @click="changeTabs(item.val)"
          v-for="item in tabslist"
          :key="item.val"
        >
          {{ item.label }}
        </li>
      </ul>
      <div class="tabsbutton" v-if="activeId != 1">
        <el-button type="primary" size="small" @click="oneClickIsCorrect"
          >一键无误</el-button
        >
        <el-button type="primary" size="small" @click="exportFile"
          >导出</el-button
        >
      </div>
    </div>
    <div style="height: 20px"></div>
    <div class="table" v-if="activeId == 1">
      <basicList
        :config="basicListconfig"
        @search="searchEvent"
        @sortChange="sortChange"
        :key="2"
      >
        <template v-slot:operation="row">
          <div style="display: flex; align-items: center">
            <div class="button button_modify" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 更新
            </div>
          </div>
        </template>
      </basicList>
    </div>
    <div class="table" v-else-if="activeId == 2">
      <basicList
        :key="1"
        :config="dailyDiskLibraryListconfig"
        @search="dailyDiskLibrarySearchEvent"
        @dynamic="dynamic"
        @sortChange="sortChange2"
        @handleSelectionChange="handleSelectionChange"
      >
        <template v-slot:new_diff_num="row">
          <el-input
            v-model="row.row.new_diff_num"
            size="small"
            placeholder="请输入"
          ></el-input>
        </template>
        <template v-slot:operation="row">
          <div style="display: flex; align-items: center">
            <div class="button button_modify" @click="toUpdate(row.row)">
              <i class="iconfont icon-bianji"></i> 更新
            </div>
          </div>
        </template>
      </basicList>
    </div>

    <div class="table" v-else-if="activeId == 3">
      <basicList
        :config="overdueListconfig"
        @search="overdueSearchEvent"
        @sortChange="sortChange3"
        @handleSelectionChange="overduehandleSelectionChange"
      >
        <template v-slot:new_diff_num="row">
          <el-input
            v-model="row.row.new_diff_num"
            size="small"
            placeholder="请输入"
          ></el-input>
        </template>
        <template v-slot:operation="row">
          <div style="display: flex; align-items: center">
            <div class="button button_modify" @click="toUpdate(row.row)">
              <i class="iconfont icon-bianji"></i> 更新
            </div>
          </div>
        </template>
      </basicList>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getStockTakeList,
  takeStockList,
  overdueStockList,
  updateStock,
  batchUpdateShopStock,
  upAllCheckOK,
} from "@/api/inventoryFlow";
import {
  itemClassGetList,
  getshoplist,
  userPermissionShopGetList,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
const defaultParameters = {
  page: 1,
  limit: 10,
};
import axios from "axios";
import { getSession } from "@/utils/cookie";
export default {
  name: "inventoryCheck",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,

      activeId: 1,
      tabslist: [
        {
          label: "盘库记录",
          val: 1,
        },
        {
          label: "日常盘库",
          val: 2,
        },
        {
          label: "盘库逾期",
          val: 3,
        },
      ],
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            multiple: true,
            key: "class_ids",
          },

          {
            label: "货架",
            type: "input",
            key: "position",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        column: [
          {
            label: "门店",
            prop: "shop_name",
          },
          {
            label: "商品分类",
            prop: "class_name",
          },
          {
            label: "商品名称",
            prop: "name",
            width: 300,
          },
          {
            label: "货架",
            prop: "position",
          },
          {
            label: "最近盘库",
            prop: "take_time",
          },
          {
            label: "盘库误差",
            prop: "diff_num",
            sortable: true,
          },
          {
            label: "盘库人",
            prop: "take_user_name",
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },

      dailyDiskLibraryListconfig: {
        operationWidth: 100,
        buttonList: [
          {
            label: "批量更新",
            type: "primary",
            key: "batchUpdate",
          },
        ],
        loading: false,
        check: true,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            multiple: true,
            key: "class_ids",
          },
          {
            label: "",
            type: "select",
            value: 1,
            options: [
              {
                label: "全部库存",
                value: 1,
              },
              {
                label: "有库存",
                value: 2,
              },
              {
                label: "零库存",
                value: 3,
              },
            ],
            key: "type_id",
          },
          {
            label: "货架",
            type: "input",
            key: "position",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        column: [
          {
            label: "门店",
            prop: "shop_name",
          },
          {
            label: "商品大类",
            prop: "class_pname",
          },
          {
            label: "商品分类",
            prop: "class_name",
          },
          {
            label: "商品名称",
            prop: "name",
            width: 300,
          },
          {
            label: "货架",
            prop: "position",
          },
          {
            label: "均价",
            prop: "avg_price",
            isMoney: true,
          },
          {
            label: "当前库存",
            prop: "num",
            sortable: true,
            width: 120,
          },
          {
            label: "上次盘库时间",
            prop: "take_time",
            width: 120,
          },
          {
            label: "本次库存差",
            prop: "new_diff_num",
            slot: "new_diff_num",
            width: 120,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      temporaryData: [],
      overdueListconfig: {
        operationWidth: 100,
        buttonList: [
          {
            label: "批量更新",
            type: "primary",
            key: "batchUpdate",
          },
        ],
        loading: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            multiple: true,
            key: "class_ids",
          },
          {
            label: "",
            type: "select",
            value: 1,
            options: [
              {
                label: "全部库存",
                value: 1,
              },
              {
                label: "有库存",
                value: 2,
              },
              {
                label: "零库存",
                value: 3,
              },
            ],
            key: "type_id",
          },
          {
            label: "货架",
            type: "input",
            key: "position",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        check: true,
        data: [],
        column: [
          {
            label: "门店",
            prop: "shop_name",
          },
          {
            label: "商品大类",
            prop: "class_pname",
          },
          {
            label: "商品分类",
            prop: "class_name",
          },
          {
            label: "商品名称",
            prop: "name",
            width: 300,
          },
          {
            label: "货架",
            prop: "position",
          },
          {
            label: "均价",
            prop: "avg_price",
            isMoney: true,
          },
          {
            label: "当前库存",
            prop: "num",
            sortable: true,
            width: 120,
          },
          {
            label: "上次盘库时间",
            prop: "take_time",
            width: 120,
          },
          {
            label: "本次库存差",
            prop: "new_diff_num",
            slot: "new_diff_num",
            width: 120,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      temporaryData2: [],
      apiBase: process.env.VUE_APP_BASE_API || 'https://erp.zuizhenshi.cn',
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;

    this.changeTabs(1);
    this.obtainDataSource();
    this.obtainQuantity();
    this.basicListconfig.searchParameters.shop_id = JSON.parse(
      getRoles()
    ).shop_id;
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    objectToGetParams(obj) {
      const queryParams = [];
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          queryParams.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`
          );
        }
      }
      return queryParams.join("&");
    },
    // 导出文件
    exportFile() {
      let shopId =
        this.activeId == 2
          ? this.dailyDiskLibraryListconfig.searchParameters.shop_id
          : this.overdueListconfig.searchParameters.shop_id;
      if (!shopId) {
        this.$message.error(
          "当前导出结果中，含有多个门店的数据，请先进行筛选！"
        );
        return;
      }
      let getParamsString = "";
      let dailyDiskLibraryListconfig = JSON.parse(
        JSON.stringify(this.dailyDiskLibraryListconfig.searchParameters)
      );
      dailyDiskLibraryListconfig.limit = 10000;
      let overdueListconfig = JSON.parse(
        JSON.stringify(this.overdueListconfig.searchParameters)
      );
      overdueListconfig.limit = 10000;
      if (this.activeId == 2) {
        getParamsString = this.objectToGetParams(dailyDiskLibraryListconfig);
      } else {
        getParamsString = this.objectToGetParams(overdueListconfig);
      }
      let url =
        this.apiBase + "/admin/shop_stock_item/exportExcel_checkstock?" +
        getParamsString;

      axios({
        method: "GET",
        url: url,
        responseType: "blob", // 重要，设置响应类型为blob
        withCredentials: true, // 如果需要携带 cookie
        headers: {
          "x-token": getSession(), // 添加自定义请求头
        },
      })
        .then((response) => {
          // 创建一个新的 Blob 对象，使用响应数据
          const blob = new Blob([response.data]);
          // 为 Blob 生成一个链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建一个临时的 <a> 标签用于下载
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "醉真实导出数据.xlsx"); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 模拟点击进行下载
          document.body.removeChild(link); // 下载完成后移除元素
          window.URL.revokeObjectURL(downloadUrl); // 释放掉blob对象使用的内存
        })
        .catch((error) => {
          console.error("下载文件失败:", error);
        });
    },
    oneClickIsCorrect() {
      this.$confirm(
        "您确定要将“" + this.activeId == 2
          ? "日常盘库"
          : "盘库逾期" + "”列表的所有数据盘库偏差设为0吗？此操作不可撤销。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          if (this.activeId == 2) {
            if (!this.dailyDiskLibraryListconfig.searchParameters.shop_id) {
              this.$message.error("请先选择门店！");
              return;
            }
            upAllCheckOK(this.dailyDiskLibraryListconfig.searchParameters).then(
              (res) => {
                if (res.code == 1) {
                  this.$message.success("操作成功！");
                  this.changeTabs(2);
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          } else if (this.activeId == 3) {
            if (!this.overdueListconfig.searchParameters.shop_id) {
              this.$message.error("请先选择门店！");
              return;
            }
            upAllCheckOK(this.overdueListconfig.searchParameters).then(
              (res) => {
                if (res.code == 1) {
                  this.$message.success("操作成功！");
                  this.changeTabs(3);
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          }
        })
        .catch(() => {});
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    sortChange2(data) {
      this.dailyDiskLibraryListconfig.searchParameters.page = 1;
      this.dailyDiskLibraryListconfig.searchParameters.order_column = data.prop;
      this.dailyDiskLibraryListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getdailyDiskLibrary();
    },
    sortChange3(data) {
      this.overdueListconfig.searchParameters.page = 1;
      this.overdueListconfig.searchParameters.order_column = data.prop;
      this.overdueListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.obtainOverdueInventory();
    },
    toUpdate(row) {
      let data = {
        comp_id: JSON.parse(getRoles()).comp_id,
        shop_id: row.shop_id,
        item_id: row.item_id,
        user_id: JSON.parse(getRoles()).user_id,
        // num: row.num,
        diff_num: row.new_diff_num,
      };
      updateStock(data).then((res) => {
        if (res.code == 1) {
          this.$message.success("更新成功！");
          //this.changeTabs(1);
          // row.num = Number(row.new_diff_num) + Number(row.num);
          row.new_diff_num = 0;
          row.take_time = this.getNowStr();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    dynamic(val) {
      if (val == "batchUpdate") {
        if (this.temporaryData.length == 0) {
          this.$message.error("请先选择要更新的数据！");
          return;
        }
        let data = {
          comp_id: JSON.parse(getRoles()).comp_id,
          user_id: JSON.parse(getRoles()).user_id,
          list: this.temporaryData.map((row) => {
            return {
              shop_id: row.shop_id,
              item_id: row.item_id,
              num: row.num,
              diff_num: Number(row.new_diff_num),
            };
          }),
        };
        batchUpdateShopStock(data).then((res) => {
          if (res.code == 1) {
            this.$message.success("更新成功！");
            this.temporaryData.forEach((row) => {
              row.num = Number(row.new_diff_num) + Number(row.num);
              row.new_diff_num = 0;
              row.take_time = this.getNowStr();
            });
          } else {
            this.$message.success(res.data.msg);
          }
        });
      }
    },
    getNowStr() {
      const now = new Date(); // 获取当前时间
      const year = now.getFullYear(); // 获取年份
      const month = now.getMonth() + 1; // 获取月份，月份从0开始，所以加1
      const day = now.getDate(); // 获取日期
      const hours = now.getHours(); // 获取小时
      const minutes = now.getMinutes(); // 获取分钟
      const seconds = now.getSeconds(); // 获取秒数

      // 将单个数字格式化为两位数（例如，1 -> 01）
      const formatTwoDigits = (number) => (number < 10 ? "0" + number : number);

      // 格式化日期和时间
      const formattedTime = `${year}-${formatTwoDigits(
        month
      )}-${formatTwoDigits(day)} ${formatTwoDigits(hours)}:${formatTwoDigits(
        minutes
      )}:${formatTwoDigits(seconds)}`;

      return formattedTime;
    },
    overduedynamic() {
      if (this.temporaryData2.length == 0) {
        this.$message.error("请先选择要更新的数据！");
        return;
      }
      let data = {
        comp_id: JSON.parse(getRoles()).comp_id,
        user_id: JSON.parse(getRoles()).user_id,
        list: this.temporaryData2.map((row) => {
          return {
            shop_id: row.shop_id,
            item_id: row.item_id,
            num: row.num,
            diff_num: row.new_diff_num,
          };
        }),
      };
      batchUpdateShopStock(data).then((res) => {
        if (res.code == 1) {
          this.$message.success("更新成功！");
          // this.changeTabs(1);
          this.temporaryData2.forEach((row) => {
            row.num = Number(row.new_diff_num) + Number(row.num);
            row.new_diff_num = 0;
            row.take_time = this.getNowStr();
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    overduehandleSelectionChange(val) {
      this.temporaryData2 = val;
    },
    obtainQuantity(shop_id) {
      overdueStockList({
        comp_id: JSON.parse(getRoles()).comp_id,
        shop_id: shop_id,
      }).then((res) => {
        if (res.code == 1) {
          this.tabslist.map((element) => {
            if (element.val == 3) {
              element.label = "盘库逾期(" + res.count + ")";
            }
            return element;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 盘库逾期
    obtainOverdueInventory() {
      this.overdueListconfig.search.map((item) => {
        if (item.key == "type_id") {
          item.value = this.overdueListconfig.searchParameters.type_id;
        }
        return item;
      });
      this.overdueListconfig.loading = true;
      this.overdueListconfig.searchParameters.comp_id = this.compId;
      if (this.roleId == 4) {
        if (
          !this.overdueListconfig.searchParameters.hasOwnProperty("shop_id")
        ) {
          this.overdueListconfig.searchParameters.shop_id = this.shopId;
        }
        if (
          this.overdueListconfig.searchParameters.hasOwnProperty("shop_id") &&
          this.overdueListconfig.searchParameters.shop_id == ""
        ) {
          let shop_ids = this.overdueListconfig.search[0].options
            .map((item) => item.value)
            .join(",");
          this.overdueListconfig.searchParameters.shop_id = shop_ids;
        }
      }
      overdueStockList(this.overdueListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.tabslist.map((element) => {
            if (element.val == 3) {
              element.label = "盘库逾期(" + res.count + ")";
            }
            return element;
          });
          this.overdueListconfig.loading = false;
          this.overdueListconfig.data = res.data.map((item) => {
            if (
              item.take_time.substring(0, 4) == "0000" ||
              item.take_time.substring(0, 4) == "1970"
            ) {
              item.take_time = "-";
            }
            return item;
          });
          this.overdueListconfig.total = res.count;
        } else {
          this.overdueListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange(val) {
      this.temporaryData = val;
    },
    overdueSearchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.overdueListconfig.page = page;
        if (pageSize) this.overdueListconfig.searchParameters.limit = pageSize;
        this.obtainOverdueInventory();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.overdueListconfig.searchParameters.begin_time;
              delete this.overdueListconfig.searchParameters.end_time;
              delete this.overdueListconfig.searchParameters["class_id"];
            } else {
              if (key == "class_ids") {
                this.overdueListconfig.searchParameters["class_id"] =
                  data[key].join(",");
              } else {
                this.overdueListconfig.searchParameters.begin_time =
                  data[key][0];
                this.overdueListconfig.searchParameters.end_time = data[key][1];
              }
            }
          }
          this.overdueListconfig.searchParameters[key] = data[key];
        }
        this.overdueListconfig.page = 1;
        this.obtainOverdueInventory();
      }
    },
    // 日常盘库
    dailyDiskLibrarySearchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.dailyDiskLibraryListconfig.page = page;
        if (pageSize)
          this.dailyDiskLibraryListconfig.searchParameters.limit = pageSize;
        this.getdailyDiskLibrary();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.dailyDiskLibraryListconfig.searchParameters
                .begin_time;
              delete this.dailyDiskLibraryListconfig.searchParameters.end_time;
              delete this.dailyDiskLibraryListconfig.searchParameters[
                "class_id"
              ];
            } else {
              if (key == "class_ids") {
                this.dailyDiskLibraryListconfig.searchParameters["class_id"] =
                  data[key].join(",");
              } else {
                this.dailyDiskLibraryListconfig.searchParameters.begin_time =
                  data[key][0];
                this.dailyDiskLibraryListconfig.searchParameters.end_time =
                  data[key][1];
              }
            }
          }
          this.dailyDiskLibraryListconfig.searchParameters[key] = data[key];
        }
        this.dailyDiskLibraryListconfig.page = 1;
        this.getdailyDiskLibrary();
      }
    },

    // 日常盘库
    getdailyDiskLibrary() {
      this.dailyDiskLibraryListconfig.search.map((item) => {
        if (item.key == "type_id") {
          item.value = this.dailyDiskLibraryListconfig.searchParameters.type_id;
        }
        return item;
      });
      this.dailyDiskLibraryListconfig.loading = true;
      this.dailyDiskLibraryListconfig.searchParameters.comp_id = this.compId;
      if (this.roleId == 4) {
        if (
          !this.dailyDiskLibraryListconfig.searchParameters.hasOwnProperty(
            "shop_id"
          )
        ) {
          this.dailyDiskLibraryListconfig.searchParameters.shop_id =
            this.shopId;
        }
        if (
          this.dailyDiskLibraryListconfig.searchParameters.hasOwnProperty(
            "shop_id"
          ) &&
          this.dailyDiskLibraryListconfig.searchParameters.shop_id == ""
        ) {
          let shop_ids = this.dailyDiskLibraryListconfig.search[0].options
            .map((item) => item.value)
            .join(",");
          this.dailyDiskLibraryListconfig.searchParameters.shop_id = shop_ids;
        }
      }
      takeStockList(this.dailyDiskLibraryListconfig.searchParameters).then(
        (res) => {
          if (res.code == 1) {
            this.dailyDiskLibraryListconfig.loading = false;
            this.dailyDiskLibraryListconfig.data = res.data.map((item) => {
              if (
                item.take_time.substring(0, 4) == "0000" ||
                item.take_time.substring(0, 4) == "1970"
              ) {
                item.take_time = "-";
              }
              return item;
            });
            this.dailyDiskLibraryListconfig.total = res.count;
          } else {
            this.dailyDiskLibraryListconfig.loading = false;
            this.$message.error(res.msg);
          }
        }
      );
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (data.shop_id) this.obtainQuantity(data.shop_id);
      else this.obtainQuantity();
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
              delete this.basicListconfig.searchParameters["class_id"];
            } else {
              if (key == "class_ids") {
                this.basicListconfig.searchParameters["class_id"] =
                  data[key].join(",");
              } else {
                this.basicListconfig.searchParameters.begin_time = data[key][0];
                this.basicListconfig.searchParameters.end_time = data[key][1];
              }
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    // 盘库记录
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = this.compId;

      if (this.roleId == 4) {
        if (!this.basicListconfig.searchParameters.hasOwnProperty("shop_id")) {
          this.basicListconfig.searchParameters.shop_id = this.shopId;
        }
        if (
          this.basicListconfig.searchParameters.hasOwnProperty("shop_id") &&
          this.basicListconfig.searchParameters.shop_id == ""
        ) {
          let shop_ids = this.basicListconfig.search[0].options
            .map((item) => item.value)
            .join(",");
          this.basicListconfig.searchParameters.shop_id = shop_ids;
          // this.basicListconfig.searchParameters.shop_id = this.shopId
        }
      }
      getStockTakeList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.map((item) => {
            if (
              item.take_time.substring(0, 4) == "0000" ||
              item.take_time.substring(0, 4) == "1970"
            ) {
              item.take_time = "-";
            }
            return item;
          });
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    changeTabs(id) {
      this.activeId = id;
      if (id == 1) {
        this.getlist();
        // 在这一页，把其他两页的残留数据清理掉
        this.dailyDiskLibraryListconfig.data = [];
        this.overdueListconfig.data = [];
      } else if (id == 2) {
        this.dailyDiskLibrarySearchEvent({ type_id: 1 });
      } else if (id == 3) {
        this.overdueSearchEvent({ type_id: 1 });
      }
    },
    // 获取数据源
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_ids") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
          this.dailyDiskLibraryListconfig.search.map((item) => {
            if (item.key == "class_ids") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
          this.overdueListconfig.search.map((item) => {
            if (item.key == "class_ids") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });

      // 加入权限位拉店面
      if (this.roleId == 4) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("库存-库存盘点-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              this.basicListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });
              this.dailyDiskLibraryListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });
              this.overdueListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });

        // 高级别所看门店不受控制
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              this.basicListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });
              this.dailyDiskLibraryListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });
              this.overdueListconfig.search.map((item) => {
                if (item.key == "shop_id") {
                  item.options = res.data.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  });
                }
                return item;
              });
            });
          } else if (res.code == 0) {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/inventoryCheck/index.vue